import $ from 'jquery';

import widgetFactory from '../widgetFactory';
import elementErrorWidget from './elementError';

const widgetName = 'formError';

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    this._super(widgetName);

    this.elements.$form = this.element;
    this.elements.$errors = {};

    this.formName = this.elements.$form.attr('name');
  },

  _getInputElementSelector: function (name) {
    return '[name=' + this.formName + '\\[' + name + '\\]]';
  },

  _getInputElement: function (name) {
    return $(this._getInputElementSelector(name), this.elements.$form);
  },

  setErrors: function (errors) {
    var hasFieldErrors = false;

    Object.keys(errors).forEach(
      function (inputName) {
        var $input = this._getInputElement(inputName),
          errorWidget;

        if ($input.length > 0) {
          hasFieldErrors = true;
          this.elements.$errors[inputName] = $input;

          errorWidget = $input.data('OC-elementError') || elementErrorWidget.create($input);

          errorWidget.setMessage(errors[inputName]).show();

          $input.off('focus.formError').on(
            'focus.formError',
            function () {
              this.resetError(inputName);
              errorWidget.hide();
            }.bind(this)
          );
        }
      }.bind(this)
    );

    if (hasFieldErrors) {
      this.elements.$form.addClass('has-fieldErrors');
    }
  },

  resetError: function (inputName) {
    if (this.elements.$errors[inputName]) {
      delete this.elements.$errors[inputName];

      if (Object.keys(this.elements.$errors).length === 0) {
        this.elements.$form.removeClass('has-fieldErrors');
      }
    }
  },

  resetAllErrors: function () {
    Object.keys(this.elements.$errors).forEach(
      function (errorName) {
        this.resetError(errorName);
      }.bind(this)
    );
  },
});

export default widget;
